export default [
  { value: "Unspecified", text: "Unspecified" },
  { value: "Plus", text: "Plus" },
  { value: "Silver", text: "Silver" },
  { value: "Gold", text: "Gold" },
  { value: "Platinum", text: "Platinum" },
  { value: "Presidential", text: "Presidential" }
];
